<template>
  <div>
    <soft-table
      :pending="false"
      class="table align-items-center table-flush"
      tbody-classes="list"
      @rowSelected="tbSetRowSelected"
      @rowClicked="tbRowClicked"
      @doDeleteRow="handleDeletes"
      @doEditRow="handleEdit"
      :fields="fields"
      :dataTable="customerContacts"
      :norecordAdd="handleAddNew"
      ref="soft-table"
      :contextMenus="[
        {
          key: 'new',
          icon: 'fa-plus',
          label: 'Thêm mới'
        },
        {
          key: 'copy',
          icon: 'fa-copy',
          label: 'Copy dòng này'
        },
        {
          key: 'edit',
          icon: 'fa-edit',
          label: 'Chỉnh sửa dòng này'
        }
      ]"
      @contextMenuItemClick="tbHandleContextMenuItemClick"
    >
      <template v-slot:cell(name)="{ item }">
        {{ item.name }}
        <i
          v-if="item.isDefault"
          style="color:rgb(247, 186, 42)"
          class="fas fa-star"
        ></i>
      </template>
      <template v-slot:cell(type)="{ item }">
        <span v-if="item.type == 'SHIP'" class="badge badge-pill badge-info">
          Người nhận hàng
        </span>
        <span
          v-else-if="item.type == 'PAYMENT'"
          class="badge badge-pill badge-success"
        >
          Người thanh toán
        </span>
        <span
          v-else-if="item.type == 'ORDER'"
          class="badge badge-pill badge-primary"
        >
          Người đặt hàng
        </span>
        <span v-else class="badge badge-pill badge-danger">
          Không phân loại
        </span>
      </template>
      <template v-slot:cell(action)="{ item }">
        <button
          @click="handleSetDefault(item)"
          class="btn btn-sm"
          :class="{
            'btn-outline-primary': !item.isDefault,
            'btn-warning': item.isDefault
          }"
        >
          Mặc định
        </button>
      </template>
    </soft-table>
    <control-mini
      :countChecked="countChecked"
      @doAddNew="handleAddNew"
      @doEdit="handleEdit"
      @search="handleSearch"
      @doDelete="handleDeletes"
    ></control-mini>
    <cs-contact-modal
      @submit:success="$emit('changeData')"
      ref="cs-contact-modal"
    />
  </div>
</template>

<script>
import { customerService } from "@/_services";
import CustomerContactModal from "./CustomerContactModal";
import SoftTable from "@/components/SoftComponents/SoftTable";
import { setDefault } from "@/_services/modules/customerContact.service";
export default {
  data() {
    return {
      countChecked: 0,
      customer: {},
      customerContacts: [],
      customerContactSelecteds: [],
      customerContact: {},
      lastIndexCustomerSelected: 0,
      fields: [
        {
          variant: "primary",
          key: "id",
          class: "checkbox"
        },
        {
          key: "name",
          label: "Họ tên",
          sortable: true
        },
        {
          key: "phone",
          label: "Số điện thoại",
          sortable: true
        },
        {
          key: "address",
          label: "Địa chỉ",
          sortable: true
        },
        {
          key: "position",
          label: "Chức vụ",
          sortable: true
        },
        {
          key: "email",
          label: "Email",
          sortable: true
        },
        {
          key: "type",
          label: "Loại",
          filterByFormatted: true,
          sortable: true
        },
        "action"
      ]
    };
  },
  methods: {
    handleSetDefault(row) {
      this.$swal({
        title: "Bạn muốn chọn người này làm liên hệ chính?",
        html: `Đừng lo, bạn có thể cập nhật lại`,
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Không",
        reverseButtons: true
      }).then(async res => {
        if (res.value) {
          const res = await setDefault(row.id);
          this.$emit("changeData", res.data);
        }
      });
    },
    handleAddNew() {
      this.$refs["cs-contact-modal"].visible = true;
      this.$refs["cs-contact-modal"].setData(this.customer, {
        type: "ORDER",
        isDefault: true
      });
    },
    tbRowClicked(item, index) {
      // this.customer = item;
      this.lastIndexCustomerSelected = index;
      this.customerContact = item;
      if (this.countChecked == 0) this.countChecked = 1;
    },
    tbSetRowSelected(items) {
      this.customerContactSelecteds = items;
      this.countChecked = items.length;
    },
    setData(customer) {
      this.customer = customer;
      this.customerContacts = this.customer.customerContacts;
      this.$refs["soft-table"].selectRow(this.lastIndexCustomerSelected);
      this.countChecked = 0;
      this.$refs["cs-contact-modal"].setData(this.customer, false);
    },
    handleEdit() {
      this.$refs["cs-contact-modal"].visible = true;
      this.$refs["cs-contact-modal"].setData(
        this.customer,
        Object.assign({}, this.customerContact)
      );
    },
    handleSearch(keyword) {
      if (keyword == "") {
        this.customerContacts = this.customer.customerContacts;
      } else {
        this.customerContacts = this.customer.customerContacts.filter(item => {
          //let keys = Object.keys(item)
          let keysCheck = ["name", "phone", "address", "email"];
          for (let i = 0; i < keysCheck.length; i++) {
            const key = keysCheck[i];
            let value = item[key];
            if (
              value &&
              value
                .toString()
                .toLowerCase()
                .includes(keyword.toLowerCase())
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    handleDeletes() {
      let list = [];
      this.customerContactSelecteds.forEach(element => {
        list.push(element.id);
      });
      customerService.removeContactList({ list: list }).finally(() => {
        this.$emit("changeData");
      });
    },
    tbHandleContextMenuItemClick(a) {
      if (a.menu.key == "spec_feature") {
        this.$refs.specFeatureModal.visible = true;
        this.$refs.specFeatureModal.setData(this.product, a.data);
      } else if (a.menu.key == "copy") {
        let newItem = Object.assign({}, a.data);
        delete newItem.id;
        this.$refs["cs-contact-modal"].visible = true;
        this.$refs["cs-contact-modal"].setData(
          this.customer,
          Object.assign({}, newItem)
        );
      } else if (a.menu.key == "edit") {
        this.$refs["cs-contact-modal"].visible = true;
        this.$refs["cs-contact-modal"].setData(
          this.customer,
          Object.assign({}, a.data)
        );
      } else if (a.menu.key == "new") {
        this.handleAddNew();
      }
    }
  },
  components: {
    SoftTable,
    "cs-contact-modal": CustomerContactModal
  }
};
</script>

<style></style>
